import { GrowthDataSet } from '../../types/data-set.types';

// Partial dataset as example based on the provided data
export const whoGirlsWeightForLength0to2: GrowthDataSet = {
  id: 'who-girls-weight-for-length-0-2',
  source: 'WHO',
  title: 'Weight-for-length (Girls, Birth to 2 years)',
  gender: 'female',
  measurementType: 'weight_for_length',
  lengthRange: {
    min: 45,
    max: 110,
  },
  displayUnit: 'kg',
  dataPoints: [
    {
      length: 45,
      m: 2.4607,
      s: 0.09029,
      percentiles: {
        p1: 2,
        p3: 2.1,
        p5: 2.1,
        p15: 2.2,
        p25: 2.3,
        p50: 2.5,
        p75: 2.6,
        p85: 2.7,
        p95: 2.9,
        p97: 2.9,
        p99: 3.1,
      },
    },
    {
      length: 45.5,
      m: 2.5457,
      s: 0.09033,
      percentiles: {
        p1: 2.1,
        p3: 2.2,
        p5: 2.2,
        p15: 2.3,
        p25: 2.4,
        p50: 2.5,
        p75: 2.7,
        p85: 2.8,
        p95: 3,
        p97: 3,
        p99: 3.2,
      },
    },
    {
      length: 46,
      m: 2.6306,
      s: 0.09037,
      percentiles: {
        p1: 2.1,
        p3: 2.2,
        p5: 2.3,
        p15: 2.4,
        p25: 2.5,
        p50: 2.6,
        p75: 2.8,
        p85: 2.9,
        p95: 3.1,
        p97: 3.1,
        p99: 3.3,
      },
    },
    {
      length: 46.5,
      m: 2.7155,
      s: 0.0904,
      percentiles: {
        p1: 2.2,
        p3: 2.3,
        p5: 2.3,
        p15: 2.5,
        p25: 2.6,
        p50: 2.7,
        p75: 2.9,
        p85: 3,
        p95: 3.2,
        p97: 3.2,
        p99: 3.4,
      },
    },
    {
      length: 47,
      m: 2.8007,
      s: 0.09044,
      percentiles: {
        p1: 2.3,
        p3: 2.4,
        p5: 2.4,
        p15: 2.6,
        p25: 2.6,
        p50: 2.8,
        p75: 3,
        p85: 3.1,
        p95: 3.3,
        p97: 3.3,
        p99: 3.5,
      },
    },
    {
      length: 47.5,
      m: 2.8867,
      s: 0.09048,
      percentiles: {
        p1: 2.4,
        p3: 2.4,
        p5: 2.5,
        p15: 2.6,
        p25: 2.7,
        p50: 2.9,
        p75: 3.1,
        p85: 3.2,
        p95: 3.4,
        p97: 3.4,
        p99: 3.6,
      },
    },
    {
      length: 48,
      m: 2.9741,
      s: 0.09052,
      percentiles: {
        p1: 2.4,
        p3: 2.5,
        p5: 2.6,
        p15: 2.7,
        p25: 2.8,
        p50: 3,
        p75: 3.2,
        p85: 3.3,
        p95: 3.5,
        p97: 3.5,
        p99: 3.7,
      },
    },
    {
      length: 48.5,
      m: 3.0636,
      s: 0.09056,
      percentiles: {
        p1: 2.5,
        p3: 2.6,
        p5: 2.7,
        p15: 2.8,
        p25: 2.9,
        p50: 3.1,
        p75: 3.3,
        p85: 3.4,
        p95: 3.6,
        p97: 3.7,
        p99: 3.8,
      },
    },
    {
      length: 49,
      m: 3.156,
      s: 0.0906,
      percentiles: {
        p1: 2.6,
        p3: 2.7,
        p5: 2.7,
        p15: 2.9,
        p25: 3,
        p50: 3.2,
        p75: 3.4,
        p85: 3.5,
        p95: 3.7,
        p97: 3.8,
        p99: 3.9,
      },
    },
    {
      length: 49.5,
      m: 3.252,
      s: 0.09064,
      percentiles: {
        p1: 2.7,
        p3: 2.8,
        p5: 2.8,
        p15: 3,
        p25: 3.1,
        p50: 3.3,
        p75: 3.5,
        p85: 3.6,
        p95: 3.8,
        p97: 3.9,
        p99: 4.1,
      },
    },
    {
      length: 50,
      m: 3.3518,
      s: 0.09068,
      percentiles: {
        p1: 2.7,
        p3: 2.8,
        p5: 2.9,
        p15: 3.1,
        p25: 3.2,
        p50: 3.4,
        p75: 3.6,
        p85: 3.7,
        p95: 3.9,
        p97: 4,
        p99: 4.2,
      },
    },
    {
      length: 50.5,
      m: 3.4557,
      s: 0.09072,
      percentiles: {
        p1: 2.8,
        p3: 2.9,
        p5: 3,
        p15: 3.2,
        p25: 3.3,
        p50: 3.5,
        p75: 3.7,
        p85: 3.8,
        p95: 4,
        p97: 4.1,
        p99: 4.3,
      },
    },
    {
      length: 51,
      m: 3.5636,
      s: 0.09076,
      percentiles: {
        p1: 2.9,
        p3: 3,
        p5: 3.1,
        p15: 3.2,
        p25: 3.4,
        p50: 3.6,
        p75: 3.8,
        p85: 3.9,
        p95: 4.2,
        p97: 4.3,
        p99: 4.4,
      },
    },
    {
      length: 51.5,
      m: 3.6754,
      s: 0.0908,
      percentiles: {
        p1: 3,
        p3: 3.1,
        p5: 3.2,
        p15: 3.4,
        p25: 3.5,
        p50: 3.7,
        p75: 3.9,
        p85: 4,
        p95: 4.3,
        p97: 4.4,
        p99: 4.6,
      },
    },
    {
      length: 52,
      m: 3.7911,
      s: 0.09085,
      percentiles: {
        p1: 3.1,
        p3: 3.2,
        p5: 3.3,
        p15: 3.5,
        p25: 3.6,
        p50: 3.8,
        p75: 4,
        p85: 4.2,
        p95: 4.4,
        p97: 4.5,
        p99: 4.7,
      },
    },
    {
      length: 52.5,
      m: 3.9105,
      s: 0.09089,
      percentiles: {
        p1: 3.2,
        p3: 3.3,
        p5: 3.4,
        p15: 3.6,
        p25: 3.7,
        p50: 3.9,
        p75: 4.2,
        p85: 4.3,
        p95: 4.6,
        p97: 4.7,
        p99: 4.9,
      },
    },
    {
      length: 53,
      m: 4.0332,
      s: 0.09093,
      percentiles: {
        p1: 3.3,
        p3: 3.4,
        p5: 3.5,
        p15: 3.7,
        p25: 3.8,
        p50: 4,
        p75: 4.3,
        p85: 4.4,
        p95: 4.7,
        p97: 4.8,
        p99: 5,
      },
    },
    {
      length: 53.5,
      m: 4.1591,
      s: 0.09098,
      percentiles: {
        p1: 3.4,
        p3: 3.5,
        p5: 3.6,
        p15: 3.8,
        p25: 3.9,
        p50: 4.2,
        p75: 4.4,
        p85: 4.6,
        p95: 4.9,
        p97: 5,
        p99: 5.2,
      },
    },
    {
      length: 54,
      m: 4.2875,
      s: 0.09102,
      percentiles: {
        p1: 3.5,
        p3: 3.6,
        p5: 3.7,
        p15: 3.9,
        p25: 4,
        p50: 4.3,
        p75: 4.6,
        p85: 4.7,
        p95: 5,
        p97: 5.1,
        p99: 5.3,
      },
    },
    {
      length: 54.5,
      m: 4.4179,
      s: 0.09106,
      percentiles: {
        p1: 3.6,
        p3: 3.7,
        p5: 3.8,
        p15: 4,
        p25: 4.2,
        p50: 4.4,
        p75: 4.7,
        p85: 4.9,
        p95: 5.2,
        p97: 5.3,
        p99: 5.5,
      },
    },
    {
      length: 55,
      m: 4.5498,
      s: 0.0911,
      percentiles: {
        p1: 3.7,
        p3: 3.9,
        p5: 3.9,
        p15: 4.1,
        p25: 4.3,
        p50: 4.5,
        p75: 4.8,
        p85: 5,
        p95: 5.3,
        p97: 5.4,
        p99: 5.7,
      },
    },
    {
      length: 55.5,
      m: 4.6827,
      s: 0.09114,
      percentiles: {
        p1: 3.8,
        p3: 4,
        p5: 4,
        p15: 4.3,
        p25: 4.4,
        p50: 4.7,
        p75: 5,
        p85: 5.2,
        p95: 5.5,
        p97: 5.6,
        p99: 5.8,
      },
    },
    {
      length: 56,
      m: 4.8162,
      s: 0.09118,
      percentiles: {
        p1: 3.9,
        p3: 4.1,
        p5: 4.2,
        p15: 4.4,
        p25: 4.5,
        p50: 4.8,
        p75: 5.1,
        p85: 5.3,
        p95: 5.6,
        p97: 5.8,
        p99: 6,
      },
    },
    {
      length: 56.5,
      m: 4.95,
      s: 0.09121,
      percentiles: {
        p1: 4,
        p3: 4.2,
        p5: 4.3,
        p15: 4.5,
        p25: 4.7,
        p50: 5,
        p75: 5.3,
        p85: 5.5,
        p95: 5.8,
        p97: 5.9,
        p99: 6.2,
      },
    },
    {
      length: 57,
      m: 5.0837,
      s: 0.09125,
      percentiles: {
        p1: 4.1,
        p3: 4.3,
        p5: 4.4,
        p15: 4.6,
        p25: 4.8,
        p50: 5.1,
        p75: 5.4,
        p85: 5.6,
        p95: 5.9,
        p97: 6.1,
        p99: 6.3,
      },
    },
    {
      length: 57.5,
      m: 5.2173,
      s: 0.09128,
      percentiles: {
        p1: 4.3,
        p3: 4.4,
        p5: 4.5,
        p15: 4.8,
        p25: 4.9,
        p50: 5.2,
        p75: 5.6,
        p85: 5.7,
        p95: 6.1,
        p97: 6.2,
        p99: 6.5,
      },
    },
    {
      length: 58,
      m: 5.3507,
      s: 0.0913,
      percentiles: {
        p1: 4.4,
        p3: 4.5,
        p5: 4.6,
        p15: 4.9,
        p25: 5,
        p50: 5.4,
        p75: 5.7,
        p85: 5.9,
        p95: 6.2,
        p97: 6.4,
        p99: 6.7,
      },
    },
    {
      length: 58.5,
      m: 5.4834,
      s: 0.09132,
      percentiles: {
        p1: 4.5,
        p3: 4.6,
        p5: 4.7,
        p15: 5,
        p25: 5.2,
        p50: 5.5,
        p75: 5.8,
        p85: 6,
        p95: 6.4,
        p97: 6.5,
        p99: 6.8,
      },
    },
    {
      length: 59,
      m: 5.6151,
      s: 0.09134,
      percentiles: {
        p1: 4.6,
        p3: 4.8,
        p5: 4.9,
        p15: 5.1,
        p25: 5.3,
        p50: 5.6,
        p75: 6,
        p85: 6.2,
        p95: 6.6,
        p97: 6.7,
        p99: 7,
      },
    },
    {
      length: 59.5,
      m: 5.7454,
      s: 0.09135,
      percentiles: {
        p1: 4.7,
        p3: 4.9,
        p5: 5,
        p15: 5.2,
        p25: 5.4,
        p50: 5.7,
        p75: 6.1,
        p85: 6.3,
        p95: 6.7,
        p97: 6.9,
        p99: 7.2,
      },
    },
    {
      length: 60,
      m: 5.8742,
      s: 0.09136,
      percentiles: {
        p1: 4.8,
        p3: 5,
        p5: 5.1,
        p15: 5.4,
        p25: 5.5,
        p50: 5.9,
        p75: 6.3,
        p85: 6.5,
        p95: 6.9,
        p97: 7,
        p99: 7.3,
      },
    },
    {
      length: 60.5,
      m: 6.0014,
      s: 0.09137,
      percentiles: {
        p1: 4.9,
        p3: 5.1,
        p5: 5.2,
        p15: 5.5,
        p25: 5.6,
        p50: 6,
        p75: 6.4,
        p85: 6.6,
        p95: 7,
        p97: 7.2,
        p99: 7.5,
      },
    },
    {
      length: 61,
      m: 6.127,
      s: 0.09137,
      percentiles: {
        p1: 5,
        p3: 5.2,
        p5: 5.3,
        p15: 5.6,
        p25: 5.8,
        p50: 6.1,
        p75: 6.5,
        p85: 6.7,
        p95: 7.2,
        p97: 7.3,
        p99: 7.6,
      },
    },
    {
      length: 61.5,
      m: 6.2511,
      s: 0.09136,
      percentiles: {
        p1: 5.1,
        p3: 5.3,
        p5: 5.4,
        p15: 5.7,
        p25: 5.9,
        p50: 6.3,
        p75: 6.7,
        p85: 6.9,
        p95: 7.3,
        p97: 7.5,
        p99: 7.8,
      },
    },
    {
      length: 62,
      m: 6.3738,
      s: 0.09135,
      percentiles: {
        p1: 5.2,
        p3: 5.4,
        p5: 5.5,
        p15: 5.8,
        p25: 6,
        p50: 6.4,
        p75: 6.8,
        p85: 7,
        p95: 7.4,
        p97: 7.6,
        p99: 8,
      },
    },
    {
      length: 62.5,
      m: 6.4948,
      s: 0.09133,
      percentiles: {
        p1: 5.3,
        p3: 5.5,
        p5: 5.6,
        p15: 5.9,
        p25: 6.1,
        p50: 6.5,
        p75: 6.9,
        p85: 7.2,
        p95: 7.6,
        p97: 7.8,
        p99: 8.1,
      },
    },
    {
      length: 63,
      m: 6.6144,
      s: 0.09131,
      percentiles: {
        p1: 5.4,
        p3: 5.6,
        p5: 5.7,
        p15: 6,
        p25: 6.2,
        p50: 6.6,
        p75: 7,
        p85: 7.3,
        p95: 7.7,
        p97: 7.9,
        p99: 8.3,
      },
    },
    {
      length: 63.5,
      m: 6.7328,
      s: 0.09129,
      percentiles: {
        p1: 5.5,
        p3: 5.7,
        p5: 5.8,
        p15: 6.1,
        p25: 6.3,
        p50: 6.7,
        p75: 7.2,
        p85: 7.4,
        p95: 7.9,
        p97: 8,
        p99: 8.4,
      },
    },
    {
      length: 64,
      m: 6.8501,
      s: 0.09126,
      percentiles: {
        p1: 5.6,
        p3: 5.8,
        p5: 5.9,
        p15: 6.2,
        p25: 6.4,
        p50: 6.9,
        p75: 7.3,
        p85: 7.5,
        p95: 8,
        p97: 8.2,
        p99: 8.5,
      },
    },
    {
      length: 64.5,
      m: 6.9662,
      s: 0.09123,
      percentiles: {
        p1: 5.7,
        p3: 5.9,
        p5: 6,
        p15: 6.3,
        p25: 6.6,
        p50: 7,
        p75: 7.4,
        p85: 7.7,
        p95: 8.1,
        p97: 8.3,
        p99: 8.7,
      },
    },
    {
      length: 65,
      m: 7.0812,
      s: 0.09119,
      percentiles: {
        p1: 5.8,
        p3: 6,
        p5: 6.1,
        p15: 6.5,
        p25: 6.7,
        p50: 7.1,
        p75: 7.5,
        p85: 7.8,
        p95: 8.3,
        p97: 8.5,
        p99: 8.8,
      },
    },
    {
      length: 65.5,
      m: 7.195,
      s: 0.09115,
      percentiles: {
        p1: 5.9,
        p3: 6.1,
        p5: 6.2,
        p15: 6.6,
        p25: 6.8,
        p50: 7.2,
        p75: 7.7,
        p85: 7.9,
        p95: 8.4,
        p97: 8.6,
        p99: 9,
      },
    },
    {
      length: 66,
      m: 7.3076,
      s: 0.0911,
      percentiles: {
        p1: 6,
        p3: 6.2,
        p5: 6.3,
        p15: 6.7,
        p25: 6.9,
        p50: 7.3,
        p75: 7.8,
        p85: 8,
        p95: 8.5,
        p97: 8.7,
        p99: 9.1,
      },
    },
    {
      length: 66.5,
      m: 7.4189,
      s: 0.09106,
      percentiles: {
        p1: 6.1,
        p3: 6.3,
        p5: 6.4,
        p15: 6.8,
        p25: 7,
        p50: 7.4,
        p75: 7.9,
        p85: 8.2,
        p95: 8.7,
        p97: 8.9,
        p99: 9.3,
      },
    },
    {
      length: 67,
      m: 7.5288,
      s: 0.09101,
      percentiles: {
        p1: 6.1,
        p3: 6.4,
        p5: 6.5,
        p15: 6.9,
        p25: 7.1,
        p50: 7.5,
        p75: 8,
        p85: 8.3,
        p95: 8.8,
        p97: 9,
        p99: 9.4,
      },
    },
    {
      length: 67.5,
      m: 7.6375,
      s: 0.09096,
      percentiles: {
        p1: 6.2,
        p3: 6.5,
        p5: 6.6,
        p15: 7,
        p25: 7.2,
        p50: 7.6,
        p75: 8.1,
        p85: 8.4,
        p95: 8.9,
        p97: 9.1,
        p99: 9.5,
      },
    },
    {
      length: 68,
      m: 7.7448,
      s: 0.0909,
      percentiles: {
        p1: 6.3,
        p3: 6.6,
        p5: 6.7,
        p15: 7.1,
        p25: 7.3,
        p50: 7.7,
        p75: 8.2,
        p85: 8.5,
        p95: 9,
        p97: 9.2,
        p99: 9.7,
      },
    },
    {
      length: 68.5,
      m: 7.8509,
      s: 0.09085,
      percentiles: {
        p1: 6.4,
        p3: 6.7,
        p5: 6.8,
        p15: 7.2,
        p25: 7.4,
        p50: 7.9,
        p75: 8.4,
        p85: 8.6,
        p95: 9.2,
        p97: 9.4,
        p99: 9.8,
      },
    },
    {
      length: 69,
      m: 7.9559,
      s: 0.09079,
      percentiles: {
        p1: 6.5,
        p3: 6.7,
        p5: 6.9,
        p15: 7.3,
        p25: 7.5,
        p50: 8,
        p75: 8.5,
        p85: 8.8,
        p95: 9.3,
        p97: 9.5,
        p99: 9.9,
      },
    },
    {
      length: 69.5,
      m: 8.0599,
      s: 0.09074,
      percentiles: {
        p1: 6.6,
        p3: 6.8,
        p5: 7,
        p15: 7.3,
        p25: 7.6,
        p50: 8.1,
        p75: 8.6,
        p85: 8.9,
        p95: 9.4,
        p97: 9.6,
        p99: 10,
      },
    },
    {
      length: 70,
      m: 8.163,
      s: 0.09068,
      percentiles: {
        p1: 6.7,
        p3: 6.9,
        p5: 7.1,
        p15: 7.4,
        p25: 7.7,
        p50: 8.2,
        p75: 8.7,
        p85: 9,
        p95: 9.5,
        p97: 9.7,
        p99: 10.2,
      },
    },
    {
      length: 70.5,
      m: 8.2651,
      s: 0.09062,
      percentiles: {
        p1: 6.7,
        p3: 7,
        p5: 7.1,
        p15: 7.5,
        p25: 7.8,
        p50: 8.3,
        p75: 8.8,
        p85: 9.1,
        p95: 9.6,
        p97: 9.9,
        p99: 10.3,
      },
    },
    {
      length: 71,
      m: 8.3666,
      s: 0.09056,
      percentiles: {
        p1: 6.8,
        p3: 7.1,
        p5: 7.2,
        p15: 7.6,
        p25: 7.9,
        p50: 8.4,
        p75: 8.9,
        p85: 9.2,
        p95: 9.8,
        p97: 10,
        p99: 10.4,
      },
    },
    {
      length: 71.5,
      m: 8.4676,
      s: 0.0905,
      percentiles: {
        p1: 6.9,
        p3: 7.2,
        p5: 7.3,
        p15: 7.7,
        p25: 8,
        p50: 8.5,
        p75: 9,
        p85: 9.3,
        p95: 9.9,
        p97: 10.1,
        p99: 10.5,
      },
    },
    {
      length: 72,
      m: 8.5679,
      s: 0.09043,
      percentiles: {
        p1: 7,
        p3: 7.3,
        p5: 7.4,
        p15: 7.8,
        p25: 8.1,
        p50: 8.6,
        p75: 9.1,
        p85: 9.4,
        p95: 10,
        p97: 10.2,
        p99: 10.7,
      },
    },
    {
      length: 72.5,
      m: 8.6674,
      s: 0.09037,
      percentiles: {
        p1: 7.1,
        p3: 7.4,
        p5: 7.5,
        p15: 7.9,
        p25: 8.2,
        p50: 8.7,
        p75: 9.2,
        p85: 9.5,
        p95: 10.1,
        p97: 10.3,
        p99: 10.8,
      },
    },
    {
      length: 73,
      m: 8.7661,
      s: 0.09031,
      percentiles: {
        p1: 7.2,
        p3: 7.4,
        p5: 7.6,
        p15: 8,
        p25: 8.3,
        p50: 8.8,
        p75: 9.3,
        p85: 9.6,
        p95: 10.2,
        p97: 10.4,
        p99: 10.9,
      },
    },
    {
      length: 73.5,
      m: 8.8638,
      s: 0.09025,
      percentiles: {
        p1: 7.2,
        p3: 7.5,
        p5: 7.7,
        p15: 8.1,
        p25: 8.3,
        p50: 8.9,
        p75: 9.4,
        p85: 9.7,
        p95: 10.3,
        p97: 10.6,
        p99: 11,
      },
    },
    {
      length: 74,
      m: 8.9601,
      s: 0.09018,
      percentiles: {
        p1: 7.3,
        p3: 7.6,
        p5: 7.8,
        p15: 8.2,
        p25: 8.4,
        p50: 9,
        p75: 9.5,
        p85: 9.9,
        p95: 10.4,
        p97: 10.7,
        p99: 11.2,
      },
    },
    {
      length: 74.5,
      m: 9.0552,
      s: 0.09012,
      percentiles: {
        p1: 7.4,
        p3: 7.7,
        p5: 7.8,
        p15: 8.3,
        p25: 8.5,
        p50: 9.1,
        p75: 9.6,
        p85: 10,
        p95: 10.5,
        p97: 10.8,
        p99: 11.3,
      },
    },
    {
      length: 75,
      m: 9.149,
      s: 0.09005,
      percentiles: {
        p1: 7.5,
        p3: 7.8,
        p5: 7.9,
        p15: 8.3,
        p25: 8.6,
        p50: 9.1,
        p75: 9.7,
        p85: 10.1,
        p95: 10.7,
        p97: 10.9,
        p99: 11.4,
      },
    },
    {
      length: 75.5,
      m: 9.2418,
      s: 0.08999,
      percentiles: {
        p1: 7.6,
        p3: 7.8,
        p5: 8,
        p15: 8.4,
        p25: 8.7,
        p50: 9.2,
        p75: 9.8,
        p85: 10.2,
        p95: 10.8,
        p97: 11,
        p99: 11.5,
      },
    },
    {
      length: 76,
      m: 9.3337,
      s: 0.08992,
      percentiles: {
        p1: 7.6,
        p3: 7.9,
        p5: 8.1,
        p15: 8.5,
        p25: 8.8,
        p50: 9.3,
        p75: 9.9,
        p85: 10.3,
        p95: 10.9,
        p97: 11.1,
        p99: 11.6,
      },
    },
    {
      length: 76.5,
      m: 9.4252,
      s: 0.08985,
      percentiles: {
        p1: 7.7,
        p3: 8,
        p5: 8.2,
        p15: 8.6,
        p25: 8.9,
        p50: 9.4,
        p75: 10,
        p85: 10.4,
        p95: 11,
        p97: 11.2,
        p99: 11.7,
      },
    },
    {
      length: 77,
      m: 9.5166,
      s: 0.08979,
      percentiles: {
        p1: 7.8,
        p3: 8.1,
        p5: 8.2,
        p15: 8.7,
        p25: 9,
        p50: 9.5,
        p75: 10.1,
        p85: 10.5,
        p95: 11.1,
        p97: 11.3,
        p99: 11.8,
      },
    },
    {
      length: 77.5,
      m: 9.6086,
      s: 0.08972,
      percentiles: {
        p1: 7.9,
        p3: 8.2,
        p5: 8.3,
        p15: 8.8,
        p25: 9.1,
        p50: 9.6,
        p75: 10.2,
        p85: 10.6,
        p95: 11.2,
        p97: 11.4,
        p99: 11.9,
      },
    },
    {
      length: 78,
      m: 9.7015,
      s: 0.08965,
      percentiles: {
        p1: 7.9,
        p3: 8.2,
        p5: 8.4,
        p15: 8.9,
        p25: 9.1,
        p50: 9.7,
        p75: 10.3,
        p85: 10.7,
        p95: 11.3,
        p97: 11.5,
        p99: 12.1,
      },
    },
    {
      length: 78.5,
      m: 9.7957,
      s: 0.08959,
      percentiles: {
        p1: 8,
        p3: 8.3,
        p5: 8.5,
        p15: 8.9,
        p25: 9.2,
        p50: 9.8,
        p75: 10.4,
        p85: 10.8,
        p95: 11.4,
        p97: 11.7,
        p99: 12.2,
      },
    },
    {
      length: 79,
      m: 9.8915,
      s: 0.08952,
      percentiles: {
        p1: 8.1,
        p3: 8.4,
        p5: 8.6,
        p15: 9,
        p25: 9.3,
        p50: 9.9,
        p75: 10.5,
        p85: 10.9,
        p95: 11.5,
        p97: 11.8,
        p99: 12.3,
      },
    },
    {
      length: 79.5,
      m: 9.9892,
      s: 0.08946,
      percentiles: {
        p1: 8.2,
        p3: 8.5,
        p5: 8.7,
        p15: 9.1,
        p25: 9.4,
        p50: 10,
        p75: 10.6,
        p85: 11,
        p95: 11.6,
        p97: 11.9,
        p99: 12.4,
      },
    },
    {
      length: 80,
      m: 10.0891,
      s: 0.0894,
      percentiles: {
        p1: 8.3,
        p3: 8.6,
        p5: 8.7,
        p15: 9.2,
        p25: 9.5,
        p50: 10.1,
        p75: 10.7,
        p85: 11.1,
        p95: 11.7,
        p97: 12,
        p99: 12.5,
      },
    },
    {
      length: 80.5,
      m: 10.1916,
      s: 0.08934,
      percentiles: {
        p1: 8.3,
        p3: 8.7,
        p5: 8.8,
        p15: 9.3,
        p25: 9.6,
        p50: 10.2,
        p75: 10.8,
        p85: 11.2,
        p95: 11.9,
        p97: 12.1,
        p99: 12.7,
      },
    },
    {
      length: 81,
      m: 10.2965,
      s: 0.08928,
      percentiles: {
        p1: 8.4,
        p3: 8.8,
        p5: 8.9,
        p15: 9.4,
        p25: 9.7,
        p50: 10.3,
        p75: 10.9,
        p85: 11.3,
        p95: 12,
        p97: 12.2,
        p99: 12.8,
      },
    },
    {
      length: 81.5,
      m: 10.4041,
      s: 0.08923,
      percentiles: {
        p1: 8.5,
        p3: 8.8,
        p5: 9,
        p15: 9.5,
        p25: 9.8,
        p50: 10.4,
        p75: 11.1,
        p85: 11.4,
        p95: 12.1,
        p97: 12.4,
        p99: 12.9,
      },
    },
    {
      length: 82,
      m: 10.514,
      s: 0.08918,
      percentiles: {
        p1: 8.6,
        p3: 8.9,
        p5: 9.1,
        p15: 9.6,
        p25: 9.9,
        p50: 10.5,
        p75: 11.2,
        p85: 11.6,
        p95: 12.2,
        p97: 12.5,
        p99: 13.1,
      },
    },
    {
      length: 82.5,
      m: 10.6263,
      s: 0.08914,
      percentiles: {
        p1: 8.7,
        p3: 9,
        p5: 9.2,
        p15: 9.7,
        p25: 10,
        p50: 10.6,
        p75: 11.3,
        p85: 11.7,
        p95: 12.4,
        p97: 12.6,
        p99: 13.2,
      },
    },
    {
      length: 83,
      m: 10.741,
      s: 0.0891,
      percentiles: {
        p1: 8.8,
        p3: 9.1,
        p5: 9.3,
        p15: 9.8,
        p25: 10.1,
        p50: 10.7,
        p75: 11.4,
        p85: 11.8,
        p95: 12.5,
        p97: 12.8,
        p99: 13.3,
      },
    },
    {
      length: 83.5,
      m: 10.8578,
      s: 0.08906,
      percentiles: {
        p1: 8.9,
        p3: 9.2,
        p5: 9.4,
        p15: 9.9,
        p25: 10.2,
        p50: 10.9,
        p75: 11.5,
        p85: 11.9,
        p95: 12.6,
        p97: 12.9,
        p99: 13.5,
      },
    },
    {
      length: 84,
      m: 10.9767,
      s: 0.08903,
      percentiles: {
        p1: 9,
        p3: 9.3,
        p5: 9.5,
        p15: 10,
        p25: 10.3,
        p50: 11,
        p75: 11.7,
        p85: 12.1,
        p95: 12.8,
        p97: 13.1,
        p99: 13.6,
      },
    },
    {
      length: 84.5,
      m: 11.0974,
      s: 0.089,
      percentiles: {
        p1: 9.1,
        p3: 9.4,
        p5: 9.6,
        p15: 10.1,
        p25: 10.5,
        p50: 11.1,
        p75: 11.8,
        p85: 12.2,
        p95: 12.9,
        p97: 13.2,
        p99: 13.8,
      },
    },
    {
      length: 85,
      m: 11.2198,
      s: 0.08898,
      percentiles: {
        p1: 9.2,
        p3: 9.5,
        p5: 9.7,
        p15: 10.2,
        p25: 10.6,
        p50: 11.2,
        p75: 11.9,
        p85: 12.3,
        p95: 13,
        p97: 13.3,
        p99: 13.9,
      },
    },
    {
      length: 85.5,
      m: 11.3435,
      s: 0.08897,
      percentiles: {
        p1: 9.3,
        p3: 9.6,
        p5: 9.8,
        p15: 10.4,
        p25: 10.7,
        p50: 11.3,
        p75: 12.1,
        p85: 12.5,
        p95: 13.2,
        p97: 13.5,
        p99: 14.1,
      },
    },
    {
      length: 86,
      m: 11.4684,
      s: 0.08895,
      percentiles: {
        p1: 9.4,
        p3: 9.8,
        p5: 9.9,
        p15: 10.5,
        p25: 10.8,
        p50: 11.5,
        p75: 12.2,
        p85: 12.6,
        p95: 13.3,
        p97: 13.6,
        p99: 14.2,
      },
    },
    {
      length: 86.5,
      m: 11.594,
      s: 0.08895,
      percentiles: {
        p1: 9.5,
        p3: 9.9,
        p5: 10.1,
        p15: 10.6,
        p25: 10.9,
        p50: 11.6,
        p75: 12.3,
        p85: 12.7,
        p95: 13.5,
        p97: 13.8,
        p99: 14.4,
      },
    },
    {
      length: 87,
      m: 11.7201,
      s: 0.08895,
      percentiles: {
        p1: 9.6,
        p3: 10,
        p5: 10.2,
        p15: 10.7,
        p25: 11,
        p50: 11.7,
        p75: 12.5,
        p85: 12.9,
        p95: 13.6,
        p97: 13.9,
        p99: 14.5,
      },
    },
    {
      length: 87.5,
      m: 11.8461,
      s: 0.08895,
      percentiles: {
        p1: 9.7,
        p3: 10.1,
        p5: 10.3,
        p15: 10.8,
        p25: 11.2,
        p50: 11.8,
        p75: 12.6,
        p85: 13,
        p95: 13.8,
        p97: 14.1,
        p99: 14.7,
      },
    },
    {
      length: 88,
      m: 11.972,
      s: 0.08896,
      percentiles: {
        p1: 9.8,
        p3: 10.2,
        p5: 10.4,
        p15: 10.9,
        p25: 11.3,
        p50: 12,
        p75: 12.7,
        p85: 13.2,
        p95: 13.9,
        p97: 14.2,
        p99: 14.9,
      },
    },
    {
      length: 88.5,
      m: 12.0976,
      s: 0.08898,
      percentiles: {
        p1: 9.9,
        p3: 10.3,
        p5: 10.5,
        p15: 11,
        p25: 11.4,
        p50: 12.1,
        p75: 12.9,
        p85: 13.3,
        p95: 14.1,
        p97: 14.4,
        p99: 15,
      },
    },
    {
      length: 89,
      m: 12.2229,
      s: 0.089,
      percentiles: {
        p1: 10,
        p3: 10.4,
        p5: 10.6,
        p15: 11.2,
        p25: 11.5,
        p50: 12.2,
        p75: 13,
        p85: 13.4,
        p95: 14.2,
        p97: 14.5,
        p99: 15.2,
      },
    },
    {
      length: 89.5,
      m: 12.3477,
      s: 0.08903,
      percentiles: {
        p1: 10.1,
        p3: 10.5,
        p5: 10.7,
        p15: 11.3,
        p25: 11.6,
        p50: 12.3,
        p75: 13.1,
        p85: 13.6,
        p95: 14.4,
        p97: 14.7,
        p99: 15.3,
      },
    },
    {
      length: 90,
      m: 12.4723,
      s: 0.08906,
      percentiles: {
        p1: 10.2,
        p3: 10.6,
        p5: 10.8,
        p15: 11.4,
        p25: 11.8,
        p50: 12.5,
        p75: 13.3,
        p85: 13.7,
        p95: 14.5,
        p97: 14.8,
        p99: 15.5,
      },
    },
    {
      length: 90.5,
      m: 12.5965,
      s: 0.08909,
      percentiles: {
        p1: 10.3,
        p3: 10.7,
        p5: 10.9,
        p15: 11.5,
        p25: 11.9,
        p50: 12.6,
        p75: 13.4,
        p85: 13.8,
        p95: 14.6,
        p97: 15,
        p99: 15.6,
      },
    },
    {
      length: 91,
      m: 12.7205,
      s: 0.08913,
      percentiles: {
        p1: 10.4,
        p3: 10.8,
        p5: 11,
        p15: 11.6,
        p25: 12,
        p50: 12.7,
        p75: 13.5,
        p85: 14,
        p95: 14.8,
        p97: 15.1,
        p99: 15.8,
      },
    },
    {
      length: 91.5,
      m: 12.8443,
      s: 0.08918,
      percentiles: {
        p1: 10.5,
        p3: 10.9,
        p5: 11.1,
        p15: 11.7,
        p25: 12.1,
        p50: 12.8,
        p75: 13.7,
        p85: 14.1,
        p95: 14.9,
        p97: 15.3,
        p99: 15.9,
      },
    },
    {
      length: 92,
      m: 12.9681,
      s: 0.08923,
      percentiles: {
        p1: 10.6,
        p3: 11,
        p5: 11.2,
        p15: 11.8,
        p25: 12.2,
        p50: 13,
        p75: 13.8,
        p85: 14.2,
        p95: 15.1,
        p97: 15.4,
        p99: 16.1,
      },
    },
    {
      length: 92.5,
      m: 13.092,
      s: 0.08928,
      percentiles: {
        p1: 10.7,
        p3: 11.1,
        p5: 11.3,
        p15: 12,
        p25: 12.3,
        p50: 13.1,
        p75: 13.9,
        p85: 14.4,
        p95: 15.2,
        p97: 15.6,
        p99: 16.3,
      },
    },
    {
      length: 93,
      m: 13.2158,
      s: 0.08934,
      percentiles: {
        p1: 10.8,
        p3: 11.2,
        p5: 11.5,
        p15: 12.1,
        p25: 12.5,
        p50: 13.2,
        p75: 14,
        p85: 14.5,
        p95: 15.4,
        p97: 15.7,
        p99: 16.4,
      },
    },
    {
      length: 93.5,
      m: 13.3399,
      s: 0.08941,
      percentiles: {
        p1: 10.9,
        p3: 11.3,
        p5: 11.6,
        p15: 12.2,
        p25: 12.6,
        p50: 13.3,
        p75: 14.2,
        p85: 14.7,
        p95: 15.5,
        p97: 15.9,
        p99: 16.6,
      },
    },
    {
      length: 94,
      m: 13.4643,
      s: 0.08948,
      percentiles: {
        p1: 11,
        p3: 11.4,
        p5: 11.7,
        p15: 12.3,
        p25: 12.7,
        p50: 13.5,
        p75: 14.3,
        p85: 14.8,
        p95: 15.7,
        p97: 16,
        p99: 16.7,
      },
    },
    {
      length: 94.5,
      m: 13.5892,
      s: 0.08955,
      percentiles: {
        p1: 11.1,
        p3: 11.5,
        p5: 11.8,
        p15: 12.4,
        p25: 12.8,
        p50: 13.6,
        p75: 14.4,
        p85: 14.9,
        p95: 15.8,
        p97: 16.2,
        p99: 16.9,
      },
    },
    {
      length: 95,
      m: 13.7146,
      s: 0.08963,
      percentiles: {
        p1: 11.2,
        p3: 11.6,
        p5: 11.9,
        p15: 12.5,
        p25: 12.9,
        p50: 13.7,
        p75: 14.6,
        p85: 15.1,
        p95: 16,
        p97: 16.3,
        p99: 17,
      },
    },
    {
      length: 95.5,
      m: 13.8408,
      s: 0.08972,
      percentiles: {
        p1: 11.3,
        p3: 11.8,
        p5: 12,
        p15: 12.6,
        p25: 13,
        p50: 13.8,
        p75: 14.7,
        p85: 15.2,
        p95: 16.1,
        p97: 16.5,
        p99: 17.2,
      },
    },
    {
      length: 96,
      m: 13.9676,
      s: 0.08981,
      percentiles: {
        p1: 11.4,
        p3: 11.9,
        p5: 12.1,
        p15: 12.7,
        p25: 13.2,
        p50: 14,
        p75: 14.9,
        p85: 15.4,
        p95: 16.3,
        p97: 16.6,
        p99: 17.4,
      },
    },
    {
      length: 96.5,
      m: 14.0953,
      s: 0.0899,
      percentiles: {
        p1: 11.5,
        p3: 12,
        p5: 12.2,
        p15: 12.9,
        p25: 13.3,
        p50: 14.1,
        p75: 15,
        p85: 15.5,
        p95: 16.4,
        p97: 16.8,
        p99: 17.5,
      },
    },
    {
      length: 97,
      m: 14.2239,
      s: 0.09,
      percentiles: {
        p1: 11.6,
        p3: 12.1,
        p5: 12.3,
        p15: 13,
        p25: 13.4,
        p50: 14.2,
        p75: 15.1,
        p85: 15.6,
        p95: 16.6,
        p97: 16.9,
        p99: 17.7,
      },
    },
    {
      length: 97.5,
      m: 14.3537,
      s: 0.0901,
      percentiles: {
        p1: 11.7,
        p3: 12.2,
        p5: 12.4,
        p15: 13.1,
        p25: 13.5,
        p50: 14.4,
        p75: 15.3,
        p85: 15.8,
        p95: 16.7,
        p97: 17.1,
        p99: 17.9,
      },
    },
    {
      length: 98,
      m: 14.4848,
      s: 0.09021,
      percentiles: {
        p1: 11.8,
        p3: 12.3,
        p5: 12.5,
        p15: 13.2,
        p25: 13.6,
        p50: 14.5,
        p75: 15.4,
        p85: 15.9,
        p95: 16.9,
        p97: 17.3,
        p99: 18,
      },
    },
    {
      length: 98.5,
      m: 14.6174,
      s: 0.09033,
      percentiles: {
        p1: 11.9,
        p3: 12.4,
        p5: 12.7,
        p15: 13.3,
        p25: 13.8,
        p50: 14.6,
        p75: 15.5,
        p85: 16.1,
        p95: 17,
        p97: 17.4,
        p99: 18.2,
      },
    },
    {
      length: 99,
      m: 14.7519,
      s: 0.09044,
      percentiles: {
        p1: 12,
        p3: 12.5,
        p5: 12.8,
        p15: 13.5,
        p25: 13.9,
        p50: 14.8,
        p75: 15.7,
        p85: 16.2,
        p95: 17.2,
        p97: 17.6,
        p99: 18.4,
      },
    },
    {
      length: 99.5,
      m: 14.8882,
      s: 0.09057,
      percentiles: {
        p1: 12.2,
        p3: 12.6,
        p5: 12.9,
        p15: 13.6,
        p25: 14,
        p50: 14.9,
        p75: 15.8,
        p85: 16.4,
        p95: 17.4,
        p97: 17.8,
        p99: 18.5,
      },
    },
    {
      length: 100,
      m: 15.0267,
      s: 0.09069,
      percentiles: {
        p1: 12.3,
        p3: 12.7,
        p5: 13,
        p15: 13.7,
        p25: 14.1,
        p50: 15,
        p75: 16,
        p85: 16.5,
        p95: 17.5,
        p97: 17.9,
        p99: 18.7,
      },
    },
    {
      length: 100.5,
      m: 15.1676,
      s: 0.09083,
      percentiles: {
        p1: 12.4,
        p3: 12.9,
        p5: 13.1,
        p15: 13.8,
        p25: 14.3,
        p50: 15.2,
        p75: 16.1,
        p85: 16.7,
        p95: 17.7,
        p97: 18.1,
        p99: 18.9,
      },
    },
    {
      length: 101,
      m: 15.3108,
      s: 0.09096,
      percentiles: {
        p1: 12.5,
        p3: 13,
        p5: 13.2,
        p15: 14,
        p25: 14.4,
        p50: 15.3,
        p75: 16.3,
        p85: 16.9,
        p95: 17.9,
        p97: 18.3,
        p99: 19.1,
      },
    },
    {
      length: 101.5,
      m: 15.4564,
      s: 0.0911,
      percentiles: {
        p1: 12.6,
        p3: 13.1,
        p5: 13.4,
        p15: 14.1,
        p25: 14.5,
        p50: 15.5,
        p75: 16.4,
        p85: 17,
        p95: 18,
        p97: 18.5,
        p99: 19.3,
      },
    },
    {
      length: 102,
      m: 15.6046,
      s: 0.09125,
      percentiles: {
        p1: 12.7,
        p3: 13.2,
        p5: 13.5,
        p15: 14.2,
        p25: 14.7,
        p50: 15.6,
        p75: 16.6,
        p85: 17.2,
        p95: 18.2,
        p97: 18.6,
        p99: 19.5,
      },
    },
    {
      length: 102.5,
      m: 15.7553,
      s: 0.09139,
      percentiles: {
        p1: 12.8,
        p3: 13.3,
        p5: 13.6,
        p15: 14.4,
        p25: 14.8,
        p50: 15.8,
        p75: 16.8,
        p85: 17.4,
        p95: 18.4,
        p97: 18.8,
        p99: 19.7,
      },
    },
    {
      length: 103,
      m: 15.9087,
      s: 0.09155,
      percentiles: {
        p1: 13,
        p3: 13.5,
        p5: 13.7,
        p15: 14.5,
        p25: 15,
        p50: 15.9,
        p75: 16.9,
        p85: 17.5,
        p95: 18.6,
        p97: 19,
        p99: 19.9,
      },
    },
    {
      length: 103.5,
      m: 16.0645,
      s: 0.0917,
      percentiles: {
        p1: 13.1,
        p3: 13.6,
        p5: 13.9,
        p15: 14.6,
        p25: 15.1,
        p50: 16.1,
        p75: 17.1,
        p85: 17.7,
        p95: 18.8,
        p97: 19.2,
        p99: 20.1,
      },
    },
    {
      length: 104,
      m: 16.2229,
      s: 0.09186,
      percentiles: {
        p1: 13.2,
        p3: 13.7,
        p5: 14,
        p15: 14.8,
        p25: 15.3,
        p50: 16.2,
        p75: 17.3,
        p85: 17.9,
        p95: 19,
        p97: 19.4,
        p99: 20.3,
      },
    },
    {
      length: 104.5,
      m: 16.3837,
      s: 0.09203,
      percentiles: {
        p1: 13.3,
        p3: 13.9,
        p5: 14.1,
        p15: 14.9,
        p25: 15.4,
        p50: 16.4,
        p75: 17.4,
        p85: 18.1,
        p95: 19.1,
        p97: 19.6,
        p99: 20.5,
      },
    },
    {
      length: 105,
      m: 16.547,
      s: 0.09219,
      percentiles: {
        p1: 13.5,
        p3: 14,
        p5: 14.3,
        p15: 15.1,
        p25: 15.6,
        p50: 16.5,
        p75: 17.6,
        p85: 18.2,
        p95: 19.3,
        p97: 19.8,
        p99: 20.7,
      },
    },
    {
      length: 105.5,
      m: 16.7129,
      s: 0.09236,
      percentiles: {
        p1: 13.6,
        p3: 14.1,
        p5: 14.4,
        p15: 15.2,
        p25: 15.7,
        p50: 16.7,
        p75: 17.8,
        p85: 18.4,
        p95: 19.5,
        p97: 20,
        p99: 20.9,
      },
    },
    {
      length: 106,
      m: 16.8814,
      s: 0.09254,
      percentiles: {
        p1: 13.7,
        p3: 14.3,
        p5: 14.6,
        p15: 15.4,
        p25: 15.9,
        p50: 16.9,
        p75: 18,
        p85: 18.6,
        p95: 19.7,
        p97: 20.2,
        p99: 21.1,
      },
    },
    {
      length: 106.5,
      m: 17.0527,
      s: 0.09271,
      percentiles: {
        p1: 13.9,
        p3: 14.4,
        p5: 14.7,
        p15: 15.5,
        p25: 16,
        p50: 17.1,
        p75: 18.2,
        p85: 18.8,
        p95: 20,
        p97: 20.4,
        p99: 21.4,
      },
    },
    {
      length: 107,
      m: 17.2269,
      s: 0.09289,
      percentiles: {
        p1: 14,
        p3: 14.5,
        p5: 14.8,
        p15: 15.7,
        p25: 16.2,
        p50: 17.2,
        p75: 18.4,
        p85: 19,
        p95: 20.2,
        p97: 20.6,
        p99: 21.6,
      },
    },
    {
      length: 107.5,
      m: 17.4039,
      s: 0.09307,
      percentiles: {
        p1: 14.1,
        p3: 14.7,
        p5: 15,
        p15: 15.8,
        p25: 16.4,
        p50: 17.4,
        p75: 18.5,
        p85: 19.2,
        p95: 20.4,
        p97: 20.9,
        p99: 21.8,
      },
    },
    {
      length: 108,
      m: 17.5839,
      s: 0.09326,
      percentiles: {
        p1: 14.3,
        p3: 14.8,
        p5: 15.1,
        p15: 16,
        p25: 16.5,
        p50: 17.6,
        p75: 18.7,
        p85: 19.4,
        p95: 20.6,
        p97: 21.1,
        p99: 22.1,
      },
    },
    {
      length: 108.5,
      m: 17.7668,
      s: 0.09344,
      percentiles: {
        p1: 14.4,
        p3: 15,
        p5: 15.3,
        p15: 16.2,
        p25: 16.7,
        p50: 17.8,
        p75: 18.9,
        p85: 19.6,
        p95: 20.8,
        p97: 21.3,
        p99: 22.3,
      },
    },
    {
      length: 109,
      m: 17.9526,
      s: 0.09363,
      percentiles: {
        p1: 14.6,
        p3: 15.1,
        p5: 15.5,
        p15: 16.3,
        p25: 16.9,
        p50: 18,
        p75: 19.1,
        p85: 19.8,
        p95: 21,
        p97: 21.5,
        p99: 22.5,
      },
    },
    {
      length: 109.5,
      m: 18.1412,
      s: 0.09382,
      percentiles: {
        p1: 14.7,
        p3: 15.3,
        p5: 15.6,
        p15: 16.5,
        p25: 17,
        p50: 18.1,
        p75: 19.3,
        p85: 20,
        p95: 21.3,
        p97: 21.8,
        p99: 22.8,
      },
    },
    {
      length: 110,
      m: 18.3324,
      s: 0.09401,
      percentiles: {
        p1: 14.9,
        p3: 15.4,
        p5: 15.8,
        p15: 16.7,
        p25: 17.2,
        p50: 18.3,
        p75: 19.5,
        p85: 20.2,
        p95: 21.5,
        p97: 22,
        p99: 23,
      },
    },
  ],
};

// Placeholder for the 2-5 years dataset (to be filled later)
export const whoGirlsWeightForLength2to5: GrowthDataSet = {
  id: 'who-girls-weight-for-length-2-5',
  source: 'WHO',
  title: 'Weight-for-length (Girls, 2-5 years)',
  gender: 'female',
  measurementType: 'weight_for_length',
  lengthRange: {
    min: 65,
    max: 120,
  },
  displayUnit: 'kg',
  dataPoints: [
    {
      length: 65,
      m: 7.2402,
      s: 0.09113,
      percentiles: {
        p1: 5.9,
        p3: 6.1,
        p5: 6.3,
        p15: 6.6,
        p25: 6.8,
        p50: 7.2,
        p75: 7.7,
        p85: 8,
        p95: 8.4,
        p97: 8.6,
        p99: 9,
      },
    },
    {
      length: 65.5,
      m: 7.3523,
      s: 0.09109,
      percentiles: {
        p1: 6,
        p3: 6.2,
        p5: 6.4,
        p15: 6.7,
        p25: 6.9,
        p50: 7.4,
        p75: 7.8,
        p85: 8.1,
        p95: 8.6,
        p97: 8.8,
        p99: 9.2,
      },
    },
    {
      length: 66,
      m: 7.463,
      s: 0.09104,
      percentiles: {
        p1: 6.1,
        p3: 6.3,
        p5: 6.5,
        p15: 6.8,
        p25: 7,
        p50: 7.5,
        p75: 7.9,
        p85: 8.2,
        p95: 8.7,
        p97: 8.9,
        p99: 9.3,
      },
    },
    {
      length: 66.5,
      m: 7.5724,
      s: 0.09099,
      percentiles: {
        p1: 6.2,
        p3: 6.4,
        p5: 6.5,
        p15: 6.9,
        p25: 7.1,
        p50: 7.6,
        p75: 8.1,
        p85: 8.3,
        p95: 8.8,
        p97: 9,
        p99: 9.4,
      },
    },
    {
      length: 67,
      m: 7.6806,
      s: 0.09094,
      percentiles: {
        p1: 6.3,
        p3: 6.5,
        p5: 6.6,
        p15: 7,
        p25: 7.2,
        p50: 7.7,
        p75: 8.2,
        p85: 8.5,
        p95: 9,
        p97: 9.2,
        p99: 9.6,
      },
    },
    {
      length: 67.5,
      m: 7.7874,
      s: 0.09088,
      percentiles: {
        p1: 6.4,
        p3: 6.6,
        p5: 6.7,
        p15: 7.1,
        p25: 7.3,
        p50: 7.8,
        p75: 8.3,
        p85: 8.6,
        p95: 9.1,
        p97: 9.3,
        p99: 9.7,
      },
    },
    {
      length: 68,
      m: 7.893,
      s: 0.09083,
      percentiles: {
        p1: 6.4,
        p3: 6.7,
        p5: 6.8,
        p15: 7.2,
        p25: 7.4,
        p50: 7.9,
        p75: 8.4,
        p85: 8.7,
        p95: 9.2,
        p97: 9.4,
        p99: 9.8,
      },
    },
    {
      length: 68.5,
      m: 7.9976,
      s: 0.09077,
      percentiles: {
        p1: 6.5,
        p3: 6.8,
        p5: 6.9,
        p15: 7.3,
        p25: 7.5,
        p50: 8,
        p75: 8.5,
        p85: 8.8,
        p95: 9.3,
        p97: 9.5,
        p99: 10,
      },
    },
    {
      length: 69,
      m: 8.1012,
      s: 0.09071,
      percentiles: {
        p1: 6.6,
        p3: 6.9,
        p5: 7,
        p15: 7.4,
        p25: 7.6,
        p50: 8.1,
        p75: 8.6,
        p85: 8.9,
        p95: 9.4,
        p97: 9.7,
        p99: 10.1,
      },
    },
    {
      length: 69.5,
      m: 8.2039,
      s: 0.09065,
      percentiles: {
        p1: 6.7,
        p3: 7,
        p5: 7.1,
        p15: 7.5,
        p25: 7.7,
        p50: 8.2,
        p75: 8.7,
        p85: 9,
        p95: 9.6,
        p97: 9.8,
        p99: 10.2,
      },
    },
    {
      length: 70,
      m: 8.3058,
      s: 0.09059,
      percentiles: {
        p1: 6.8,
        p3: 7,
        p5: 7.2,
        p15: 7.6,
        p25: 7.8,
        p50: 8.3,
        p75: 8.8,
        p85: 9.1,
        p95: 9.7,
        p97: 9.9,
        p99: 10.3,
      },
    },
    {
      length: 70.5,
      m: 8.4071,
      s: 0.09053,
      percentiles: {
        p1: 6.9,
        p3: 7.1,
        p5: 7.3,
        p15: 7.7,
        p25: 7.9,
        p50: 8.4,
        p75: 8.9,
        p85: 9.3,
        p95: 9.8,
        p97: 10,
        p99: 10.5,
      },
    },
    {
      length: 71,
      m: 8.5078,
      s: 0.09047,
      percentiles: {
        p1: 6.9,
        p3: 7.2,
        p5: 7.4,
        p15: 7.8,
        p25: 8,
        p50: 8.5,
        p75: 9,
        p85: 9.4,
        p95: 9.9,
        p97: 10.1,
        p99: 10.6,
      },
    },
    {
      length: 71.5,
      m: 8.6078,
      s: 0.09041,
      percentiles: {
        p1: 7,
        p3: 7.3,
        p5: 7.4,
        p15: 7.9,
        p25: 8.1,
        p50: 8.6,
        p75: 9.2,
        p85: 9.5,
        p95: 10,
        p97: 10.3,
        p99: 10.7,
      },
    },
    {
      length: 72,
      m: 8.707,
      s: 0.09035,
      percentiles: {
        p1: 7.1,
        p3: 7.4,
        p5: 7.5,
        p15: 7.9,
        p25: 8.2,
        p50: 8.7,
        p75: 9.3,
        p85: 9.6,
        p95: 10.1,
        p97: 10.4,
        p99: 10.8,
      },
    },
    {
      length: 72.5,
      m: 8.8053,
      s: 0.09028,
      percentiles: {
        p1: 7.2,
        p3: 7.5,
        p5: 7.6,
        p15: 8,
        p25: 8.3,
        p50: 8.8,
        p75: 9.4,
        p85: 9.7,
        p95: 10.3,
        p97: 10.5,
        p99: 11,
      },
    },
    {
      length: 73,
      m: 8.9025,
      s: 0.09022,
      percentiles: {
        p1: 7.3,
        p3: 7.6,
        p5: 7.7,
        p15: 8.1,
        p25: 8.4,
        p50: 8.9,
        p75: 9.5,
        p85: 9.8,
        p95: 10.4,
        p97: 10.6,
        p99: 11.1,
      },
    },
    {
      length: 73.5,
      m: 8.9983,
      s: 0.09016,
      percentiles: {
        p1: 7.4,
        p3: 7.6,
        p5: 7.8,
        p15: 8.2,
        p25: 8.5,
        p50: 9,
        p75: 9.6,
        p85: 9.9,
        p95: 10.5,
        p97: 10.7,
        p99: 11.2,
      },
    },
    {
      length: 74,
      m: 9.0928,
      s: 0.09009,
      percentiles: {
        p1: 7.4,
        p3: 7.7,
        p5: 7.9,
        p15: 8.3,
        p25: 8.6,
        p50: 9.1,
        p75: 9.7,
        p85: 10,
        p95: 10.6,
        p97: 10.8,
        p99: 11.3,
      },
    },
    {
      length: 74.5,
      m: 9.1862,
      s: 0.09003,
      percentiles: {
        p1: 7.5,
        p3: 7.8,
        p5: 8,
        p15: 8.4,
        p25: 8.7,
        p50: 9.2,
        p75: 9.8,
        p85: 10.1,
        p95: 10.7,
        p97: 10.9,
        p99: 11.4,
      },
    },
    {
      length: 75,
      m: 9.2786,
      s: 0.08996,
      percentiles: {
        p1: 7.6,
        p3: 7.9,
        p5: 8,
        p15: 8.5,
        p25: 8.7,
        p50: 9.3,
        p75: 9.9,
        p85: 10.2,
        p95: 10.8,
        p97: 11.1,
        p99: 11.5,
      },
    },
    {
      length: 75.5,
      m: 9.3703,
      s: 0.08989,
      percentiles: {
        p1: 7.7,
        p3: 8,
        p5: 8.1,
        p15: 8.6,
        p25: 8.8,
        p50: 9.4,
        p75: 10,
        p85: 10.3,
        p95: 10.9,
        p97: 11.2,
        p99: 11.7,
      },
    },
    {
      length: 76,
      m: 9.4617,
      s: 0.08983,
      percentiles: {
        p1: 7.7,
        p3: 8,
        p5: 8.2,
        p15: 8.6,
        p25: 8.9,
        p50: 9.5,
        p75: 10.1,
        p85: 10.4,
        p95: 11,
        p97: 11.3,
        p99: 11.8,
      },
    },
    {
      length: 76.5,
      m: 9.5533,
      s: 0.08976,
      percentiles: {
        p1: 7.8,
        p3: 8.1,
        p5: 8.3,
        p15: 8.7,
        p25: 9,
        p50: 9.6,
        p75: 10.2,
        p85: 10.5,
        p95: 11.1,
        p97: 11.4,
        p99: 11.9,
      },
    },
    {
      length: 77,
      m: 9.6456,
      s: 0.08969,
      percentiles: {
        p1: 7.9,
        p3: 8.2,
        p5: 8.4,
        p15: 8.8,
        p25: 9.1,
        p50: 9.6,
        p75: 10.3,
        p85: 10.6,
        p95: 11.2,
        p97: 11.5,
        p99: 12,
      },
    },
    {
      length: 77.5,
      m: 9.739,
      s: 0.08963,
      percentiles: {
        p1: 8,
        p3: 8.3,
        p5: 8.4,
        p15: 8.9,
        p25: 9.2,
        p50: 9.7,
        p75: 10.4,
        p85: 10.7,
        p95: 11.3,
        p97: 11.6,
        p99: 12.1,
      },
    },
    {
      length: 78,
      m: 9.8338,
      s: 0.08956,
      percentiles: {
        p1: 8,
        p3: 8.4,
        p5: 8.5,
        p15: 9,
        p25: 9.3,
        p50: 9.8,
        p75: 10.5,
        p85: 10.8,
        p95: 11.4,
        p97: 11.7,
        p99: 12.2,
      },
    },
    {
      length: 78.5,
      m: 9.9303,
      s: 0.0895,
      percentiles: {
        p1: 8.1,
        p3: 8.4,
        p5: 8.6,
        p15: 9.1,
        p25: 9.4,
        p50: 9.9,
        p75: 10.6,
        p85: 10.9,
        p95: 11.6,
        p97: 11.8,
        p99: 12.3,
      },
    },
    {
      length: 79,
      m: 10.0289,
      s: 0.08943,
      percentiles: {
        p1: 8.2,
        p3: 8.5,
        p5: 8.7,
        p15: 9.2,
        p25: 9.4,
        p50: 10,
        p75: 10.7,
        p85: 11,
        p95: 11.7,
        p97: 11.9,
        p99: 12.5,
      },
    },
    {
      length: 79.5,
      m: 10.1298,
      s: 0.08937,
      percentiles: {
        p1: 8.3,
        p3: 8.6,
        p5: 8.8,
        p15: 9.2,
        p25: 9.5,
        p50: 10.1,
        p75: 10.8,
        p85: 11.1,
        p95: 11.8,
        p97: 12.1,
        p99: 12.6,
      },
    },
    {
      length: 80,
      m: 10.2332,
      s: 0.08932,
      percentiles: {
        p1: 8.4,
        p3: 8.7,
        p5: 8.9,
        p15: 9.3,
        p25: 9.6,
        p50: 10.2,
        p75: 10.9,
        p85: 11.2,
        p95: 11.9,
        p97: 12.2,
        p99: 12.7,
      },
    },
    {
      length: 80.5,
      m: 10.3393,
      s: 0.08926,
      percentiles: {
        p1: 8.5,
        p3: 8.8,
        p5: 9,
        p15: 9.4,
        p25: 9.7,
        p50: 10.3,
        p75: 11,
        p85: 11.4,
        p95: 12,
        p97: 12.3,
        p99: 12.8,
      },
    },
    {
      length: 81,
      m: 10.4477,
      s: 0.08921,
      percentiles: {
        p1: 8.6,
        p3: 8.9,
        p5: 9.1,
        p15: 9.5,
        p25: 9.8,
        p50: 10.4,
        p75: 11.1,
        p85: 11.5,
        p95: 12.2,
        p97: 12.4,
        p99: 13,
      },
    },
    {
      length: 81.5,
      m: 10.5586,
      s: 0.08916,
      percentiles: {
        p1: 8.6,
        p3: 9,
        p5: 9.2,
        p15: 9.6,
        p25: 9.9,
        p50: 10.6,
        p75: 11.2,
        p85: 11.6,
        p95: 12.3,
        p97: 12.6,
        p99: 13.1,
      },
    },
    {
      length: 82,
      m: 10.6719,
      s: 0.08912,
      percentiles: {
        p1: 8.7,
        p3: 9.1,
        p5: 9.3,
        p15: 9.7,
        p25: 10.1,
        p50: 10.7,
        p75: 11.3,
        p85: 11.7,
        p95: 12.4,
        p97: 12.7,
        p99: 13.2,
      },
    },
    {
      length: 82.5,
      m: 10.7874,
      s: 0.08908,
      percentiles: {
        p1: 8.8,
        p3: 9.2,
        p5: 9.4,
        p15: 9.9,
        p25: 10.2,
        p50: 10.8,
        p75: 11.5,
        p85: 11.9,
        p95: 12.5,
        p97: 12.8,
        p99: 13.4,
      },
    },
    {
      length: 83,
      m: 10.9051,
      s: 0.08905,
      percentiles: {
        p1: 8.9,
        p3: 9.3,
        p5: 9.5,
        p15: 10,
        p25: 10.3,
        p50: 10.9,
        p75: 11.6,
        p85: 12,
        p95: 12.7,
        p97: 13,
        p99: 13.5,
      },
    },
    {
      length: 83.5,
      m: 11.0248,
      s: 0.08902,
      percentiles: {
        p1: 9,
        p3: 9.4,
        p5: 9.6,
        p15: 10.1,
        p25: 10.4,
        p50: 11,
        p75: 11.7,
        p85: 12.1,
        p95: 12.8,
        p97: 13.1,
        p99: 13.7,
      },
    },
    {
      length: 84,
      m: 11.1462,
      s: 0.08899,
      percentiles: {
        p1: 9.1,
        p3: 9.5,
        p5: 9.7,
        p15: 10.2,
        p25: 10.5,
        p50: 11.1,
        p75: 11.8,
        p85: 12.2,
        p95: 13,
        p97: 13.3,
        p99: 13.8,
      },
    },
    {
      length: 84.5,
      m: 11.2691,
      s: 0.08897,
      percentiles: {
        p1: 9.2,
        p3: 9.6,
        p5: 9.8,
        p15: 10.3,
        p25: 10.6,
        p50: 11.3,
        p75: 12,
        p85: 12.4,
        p95: 13.1,
        p97: 13.4,
        p99: 14,
      },
    },
    {
      length: 85,
      m: 11.3934,
      s: 0.08896,
      percentiles: {
        p1: 9.3,
        p3: 9.7,
        p5: 9.9,
        p15: 10.4,
        p25: 10.7,
        p50: 11.4,
        p75: 12.1,
        p85: 12.5,
        p95: 13.2,
        p97: 13.5,
        p99: 14.1,
      },
    },
    {
      length: 85.5,
      m: 11.5186,
      s: 0.08895,
      percentiles: {
        p1: 9.4,
        p3: 9.8,
        p5: 10,
        p15: 10.5,
        p25: 10.9,
        p50: 11.5,
        p75: 12.2,
        p85: 12.7,
        p95: 13.4,
        p97: 13.7,
        p99: 14.3,
      },
    },
    {
      length: 86,
      m: 11.6444,
      s: 0.08895,
      percentiles: {
        p1: 9.5,
        p3: 9.9,
        p5: 10.1,
        p15: 10.6,
        p25: 11,
        p50: 11.6,
        p75: 12.4,
        p85: 12.8,
        p95: 13.5,
        p97: 13.8,
        p99: 14.4,
      },
    },
    {
      length: 86.5,
      m: 11.7705,
      s: 0.08895,
      percentiles: {
        p1: 9.6,
        p3: 10,
        p5: 10.2,
        p15: 10.8,
        p25: 11.1,
        p50: 11.8,
        p75: 12.5,
        p85: 12.9,
        p95: 13.7,
        p97: 14,
        p99: 14.6,
      },
    },
    {
      length: 87,
      m: 11.8965,
      s: 0.08896,
      percentiles: {
        p1: 9.7,
        p3: 10.1,
        p5: 10.3,
        p15: 10.9,
        p25: 11.2,
        p50: 11.9,
        p75: 12.6,
        p85: 13.1,
        p95: 13.8,
        p97: 14.1,
        p99: 14.8,
      },
    },
    {
      length: 87.5,
      m: 12.0223,
      s: 0.08897,
      percentiles: {
        p1: 9.9,
        p3: 10.2,
        p5: 10.4,
        p15: 11,
        p25: 11.3,
        p50: 12,
        p75: 12.8,
        p85: 13.2,
        p95: 14,
        p97: 14.3,
        p99: 14.9,
      },
    },
    {
      length: 88,
      m: 12.1478,
      s: 0.08899,
      percentiles: {
        p1: 10,
        p3: 10.3,
        p5: 10.5,
        p15: 11.1,
        p25: 11.4,
        p50: 12.1,
        p75: 12.9,
        p85: 13.3,
        p95: 14.1,
        p97: 14.4,
        p99: 15.1,
      },
    },
    {
      length: 88.5,
      m: 12.2729,
      s: 0.08901,
      percentiles: {
        p1: 10.1,
        p3: 10.4,
        p5: 10.6,
        p15: 11.2,
        p25: 11.6,
        p50: 12.3,
        p75: 13,
        p85: 13.5,
        p95: 14.3,
        p97: 14.6,
        p99: 15.2,
      },
    },
    {
      length: 89,
      m: 12.3976,
      s: 0.08904,
      percentiles: {
        p1: 10.2,
        p3: 10.5,
        p5: 10.8,
        p15: 11.3,
        p25: 11.7,
        p50: 12.4,
        p75: 13.2,
        p85: 13.6,
        p95: 14.4,
        p97: 14.7,
        p99: 15.4,
      },
    },
    {
      length: 89.5,
      m: 12.522,
      s: 0.08907,
      percentiles: {
        p1: 10.3,
        p3: 10.6,
        p5: 10.9,
        p15: 11.4,
        p25: 11.8,
        p50: 12.5,
        p75: 13.3,
        p85: 13.8,
        p95: 14.6,
        p97: 14.9,
        p99: 15.5,
      },
    },
    {
      length: 90,
      m: 12.6461,
      s: 0.08911,
      percentiles: {
        p1: 10.4,
        p3: 10.8,
        p5: 11,
        p15: 11.5,
        p25: 11.9,
        p50: 12.6,
        p75: 13.4,
        p85: 13.9,
        p95: 14.7,
        p97: 15,
        p99: 15.7,
      },
    },
    {
      length: 90.5,
      m: 12.77,
      s: 0.08915,
      percentiles: {
        p1: 10.5,
        p3: 10.9,
        p5: 11.1,
        p15: 11.7,
        p25: 12,
        p50: 12.8,
        p75: 13.6,
        p85: 14,
        p95: 14.9,
        p97: 15.2,
        p99: 15.9,
      },
    },
    {
      length: 91,
      m: 12.8939,
      s: 0.0892,
      percentiles: {
        p1: 10.6,
        p3: 11,
        p5: 11.2,
        p15: 11.8,
        p25: 12.1,
        p50: 12.9,
        p75: 13.7,
        p85: 14.2,
        p95: 15,
        p97: 15.3,
        p99: 16,
      },
    },
    {
      length: 91.5,
      m: 13.0177,
      s: 0.08925,
      percentiles: {
        p1: 10.7,
        p3: 11.1,
        p5: 11.3,
        p15: 11.9,
        p25: 12.3,
        p50: 13,
        p75: 13.8,
        p85: 14.3,
        p95: 15.1,
        p97: 15.5,
        p99: 16.2,
      },
    },
    {
      length: 92,
      m: 13.1415,
      s: 0.08931,
      percentiles: {
        p1: 10.8,
        p3: 11.2,
        p5: 11.4,
        p15: 12,
        p25: 12.4,
        p50: 13.1,
        p75: 14,
        p85: 14.4,
        p95: 15.3,
        p97: 15.6,
        p99: 16.3,
      },
    },
    {
      length: 92.5,
      m: 13.2654,
      s: 0.08937,
      percentiles: {
        p1: 10.9,
        p3: 11.3,
        p5: 11.5,
        p15: 12.1,
        p25: 12.5,
        p50: 13.3,
        p75: 14.1,
        p85: 14.6,
        p95: 15.4,
        p97: 15.8,
        p99: 16.5,
      },
    },
    {
      length: 93,
      m: 13.3896,
      s: 0.08944,
      percentiles: {
        p1: 11,
        p3: 11.4,
        p5: 11.6,
        p15: 12.2,
        p25: 12.6,
        p50: 13.4,
        p75: 14.2,
        p85: 14.7,
        p95: 15.6,
        p97: 15.9,
        p99: 16.6,
      },
    },
    {
      length: 93.5,
      m: 13.5142,
      s: 0.08951,
      percentiles: {
        p1: 11.1,
        p3: 11.5,
        p5: 11.7,
        p15: 12.3,
        p25: 12.7,
        p50: 13.5,
        p75: 14.4,
        p85: 14.9,
        p95: 15.7,
        p97: 16.1,
        p99: 16.8,
      },
    },
    {
      length: 94,
      m: 13.6393,
      s: 0.08959,
      percentiles: {
        p1: 11.2,
        p3: 11.6,
        p5: 11.8,
        p15: 12.4,
        p25: 12.8,
        p50: 13.6,
        p75: 14.5,
        p85: 15,
        p95: 15.9,
        p97: 16.2,
        p99: 16.9,
      },
    },
    {
      length: 94.5,
      m: 13.765,
      s: 0.08967,
      percentiles: {
        p1: 11.3,
        p3: 11.7,
        p5: 11.9,
        p15: 12.6,
        p25: 13,
        p50: 13.8,
        p75: 14.6,
        p85: 15.1,
        p95: 16,
        p97: 16.4,
        p99: 17.1,
      },
    },
    {
      length: 95,
      m: 13.8914,
      s: 0.08975,
      percentiles: {
        p1: 11.4,
        p3: 11.8,
        p5: 12,
        p15: 12.7,
        p25: 13.1,
        p50: 13.9,
        p75: 14.8,
        p85: 15.3,
        p95: 16.2,
        p97: 16.5,
        p99: 17.3,
      },
    },
    {
      length: 95.5,
      m: 14.0186,
      s: 0.08984,
      percentiles: {
        p1: 11.5,
        p3: 11.9,
        p5: 12.1,
        p15: 12.8,
        p25: 13.2,
        p50: 14,
        p75: 14.9,
        p85: 15.4,
        p95: 16.3,
        p97: 16.7,
        p99: 17.4,
      },
    },
    {
      length: 96,
      m: 14.1466,
      s: 0.08994,
      percentiles: {
        p1: 11.6,
        p3: 12,
        p5: 12.3,
        p15: 12.9,
        p25: 13.3,
        p50: 14.1,
        p75: 15,
        p85: 15.6,
        p95: 16.5,
        p97: 16.9,
        p99: 17.6,
      },
    },
    {
      length: 96.5,
      m: 14.2757,
      s: 0.09004,
      percentiles: {
        p1: 11.7,
        p3: 12.1,
        p5: 12.4,
        p15: 13,
        p25: 13.4,
        p50: 14.3,
        p75: 15.2,
        p85: 15.7,
        p95: 16.6,
        p97: 17,
        p99: 17.8,
      },
    },
    {
      length: 97,
      m: 14.4059,
      s: 0.09015,
      percentiles: {
        p1: 11.8,
        p3: 12.2,
        p5: 12.5,
        p15: 13.1,
        p25: 13.6,
        p50: 14.4,
        p75: 15.3,
        p85: 15.8,
        p95: 16.8,
        p97: 17.2,
        p99: 17.9,
      },
    },
    {
      length: 97.5,
      m: 14.5376,
      s: 0.09026,
      percentiles: {
        p1: 11.9,
        p3: 12.3,
        p5: 12.6,
        p15: 13.3,
        p25: 13.7,
        p50: 14.5,
        p75: 15.5,
        p85: 16,
        p95: 16.9,
        p97: 17.3,
        p99: 18.1,
      },
    },
    {
      length: 98,
      m: 14.671,
      s: 0.09037,
      percentiles: {
        p1: 12,
        p3: 12.4,
        p5: 12.7,
        p15: 13.4,
        p25: 13.8,
        p50: 14.7,
        p75: 15.6,
        p85: 16.1,
        p95: 17.1,
        p97: 17.5,
        p99: 18.3,
      },
    },
    {
      length: 98.5,
      m: 14.8062,
      s: 0.09049,
      percentiles: {
        p1: 12.1,
        p3: 12.6,
        p5: 12.8,
        p15: 13.5,
        p25: 13.9,
        p50: 14.8,
        p75: 15.7,
        p85: 16.3,
        p95: 17.3,
        p97: 17.7,
        p99: 18.4,
      },
    },
    {
      length: 99,
      m: 14.9434,
      s: 0.09062,
      percentiles: {
        p1: 12.2,
        p3: 12.7,
        p5: 12.9,
        p15: 13.6,
        p25: 14.1,
        p50: 14.9,
        p75: 15.9,
        p85: 16.4,
        p95: 17.4,
        p97: 17.8,
        p99: 18.6,
      },
    },
    {
      length: 99.5,
      m: 15.0828,
      s: 0.09075,
      percentiles: {
        p1: 12.3,
        p3: 12.8,
        p5: 13,
        p15: 13.8,
        p25: 14.2,
        p50: 15.1,
        p75: 16,
        p85: 16.6,
        p95: 17.6,
        p97: 18,
        p99: 18.8,
      },
    },
    {
      length: 100,
      m: 15.2246,
      s: 0.09088,
      percentiles: {
        p1: 12.4,
        p3: 12.9,
        p5: 13.2,
        p15: 13.9,
        p25: 14.3,
        p50: 15.2,
        p75: 16.2,
        p85: 16.8,
        p95: 17.8,
        p97: 18.2,
        p99: 19,
      },
    },
    {
      length: 100.5,
      m: 15.3687,
      s: 0.09102,
      percentiles: {
        p1: 12.5,
        p3: 13,
        p5: 13.3,
        p15: 14,
        p25: 14.5,
        p50: 15.4,
        p75: 16.4,
        p85: 16.9,
        p95: 17.9,
        p97: 18.3,
        p99: 19.2,
      },
    },
    {
      length: 101,
      m: 15.5154,
      s: 0.09116,
      percentiles: {
        p1: 12.7,
        p3: 13.1,
        p5: 13.4,
        p15: 14.1,
        p25: 14.6,
        p50: 15.5,
        p75: 16.5,
        p85: 17.1,
        p95: 18.1,
        p97: 18.5,
        p99: 19.4,
      },
    },
    {
      length: 101.5,
      m: 15.6646,
      s: 0.09131,
      percentiles: {
        p1: 12.8,
        p3: 13.3,
        p5: 13.5,
        p15: 14.3,
        p25: 14.7,
        p50: 15.7,
        p75: 16.7,
        p85: 17.2,
        p95: 18.3,
        p97: 18.7,
        p99: 19.5,
      },
    },
    {
      length: 102,
      m: 15.8164,
      s: 0.09146,
      percentiles: {
        p1: 12.9,
        p3: 13.4,
        p5: 13.7,
        p15: 14.4,
        p25: 14.9,
        p50: 15.8,
        p75: 16.8,
        p85: 17.4,
        p95: 18.5,
        p97: 18.9,
        p99: 19.7,
      },
    },
    {
      length: 102.5,
      m: 15.9707,
      s: 0.09161,
      percentiles: {
        p1: 13,
        p3: 13.5,
        p5: 13.8,
        p15: 14.5,
        p25: 15,
        p50: 16,
        p75: 17,
        p85: 17.6,
        p95: 18.7,
        p97: 19.1,
        p99: 19.9,
      },
    },
    {
      length: 103,
      m: 16.1276,
      s: 0.09177,
      percentiles: {
        p1: 13.1,
        p3: 13.6,
        p5: 13.9,
        p15: 14.7,
        p25: 15.2,
        p50: 16.1,
        p75: 17.2,
        p85: 17.8,
        p95: 18.8,
        p97: 19.3,
        p99: 20.2,
      },
    },
    {
      length: 103.5,
      m: 16.287,
      s: 0.09193,
      percentiles: {
        p1: 13.3,
        p3: 13.8,
        p5: 14.1,
        p15: 14.8,
        p25: 15.3,
        p50: 16.3,
        p75: 17.3,
        p85: 17.9,
        p95: 19,
        p97: 19.5,
        p99: 20.4,
      },
    },
    {
      length: 104,
      m: 16.4488,
      s: 0.09209,
      percentiles: {
        p1: 13.4,
        p3: 13.9,
        p5: 14.2,
        p15: 15,
        p25: 15.5,
        p50: 16.4,
        p75: 17.5,
        p85: 18.1,
        p95: 19.2,
        p97: 19.7,
        p99: 20.6,
      },
    },
    {
      length: 104.5,
      m: 16.6131,
      s: 0.09226,
      percentiles: {
        p1: 13.5,
        p3: 14,
        p5: 14.3,
        p15: 15.1,
        p25: 15.6,
        p50: 16.6,
        p75: 17.7,
        p85: 18.3,
        p95: 19.4,
        p97: 19.9,
        p99: 20.8,
      },
    },
    {
      length: 105,
      m: 16.78,
      s: 0.09243,
      percentiles: {
        p1: 13.6,
        p3: 14.2,
        p5: 14.5,
        p15: 15.3,
        p25: 15.8,
        p50: 16.8,
        p75: 17.9,
        p85: 18.5,
        p95: 19.6,
        p97: 20.1,
        p99: 21,
      },
    },
    {
      length: 105.5,
      m: 16.9496,
      s: 0.09261,
      percentiles: {
        p1: 13.8,
        p3: 14.3,
        p5: 14.6,
        p15: 15.4,
        p25: 15.9,
        p50: 16.9,
        p75: 18.1,
        p85: 18.7,
        p95: 19.8,
        p97: 20.3,
        p99: 21.2,
      },
    },
    {
      length: 106,
      m: 17.122,
      s: 0.09278,
      percentiles: {
        p1: 13.9,
        p3: 14.5,
        p5: 14.8,
        p15: 15.6,
        p25: 16.1,
        p50: 17.1,
        p75: 18.2,
        p85: 18.9,
        p95: 20,
        p97: 20.5,
        p99: 21.4,
      },
    },
    {
      length: 106.5,
      m: 17.2973,
      s: 0.09296,
      percentiles: {
        p1: 14.1,
        p3: 14.6,
        p5: 14.9,
        p15: 15.7,
        p25: 16.3,
        p50: 17.3,
        p75: 18.4,
        p85: 19.1,
        p95: 20.2,
        p97: 20.7,
        p99: 21.7,
      },
    },
    {
      length: 107,
      m: 17.4755,
      s: 0.09315,
      percentiles: {
        p1: 14.2,
        p3: 14.7,
        p5: 15.1,
        p15: 15.9,
        p25: 16.4,
        p50: 17.5,
        p75: 18.6,
        p85: 19.3,
        p95: 20.5,
        p97: 21,
        p99: 21.9,
      },
    },
    {
      length: 107.5,
      m: 17.6567,
      s: 0.09333,
      percentiles: {
        p1: 14.3,
        p3: 14.9,
        p5: 15.2,
        p15: 16.1,
        p25: 16.6,
        p50: 17.7,
        p75: 18.8,
        p85: 19.5,
        p95: 20.7,
        p97: 21.2,
        p99: 22.1,
      },
    },
    {
      length: 108,
      m: 17.8407,
      s: 0.09352,
      percentiles: {
        p1: 14.5,
        p3: 15,
        p5: 15.4,
        p15: 16.2,
        p25: 16.8,
        p50: 17.8,
        p75: 19,
        p85: 19.7,
        p95: 20.9,
        p97: 21.4,
        p99: 22.4,
      },
    },
    {
      length: 108.5,
      m: 18.0277,
      s: 0.09371,
      percentiles: {
        p1: 14.6,
        p3: 15.2,
        p5: 15.5,
        p15: 16.4,
        p25: 16.9,
        p50: 18,
        p75: 19.2,
        p85: 19.9,
        p95: 21.1,
        p97: 21.6,
        p99: 22.6,
      },
    },
    {
      length: 109,
      m: 18.2174,
      s: 0.0939,
      percentiles: {
        p1: 14.8,
        p3: 15.4,
        p5: 15.7,
        p15: 16.6,
        p25: 17.1,
        p50: 18.2,
        p75: 19.4,
        p85: 20.1,
        p95: 21.4,
        p97: 21.9,
        p99: 22.9,
      },
    },
    {
      length: 109.5,
      m: 18.4096,
      s: 0.09409,
      percentiles: {
        p1: 14.9,
        p3: 15.5,
        p5: 15.8,
        p15: 16.7,
        p25: 17.3,
        p50: 18.4,
        p75: 19.6,
        p85: 20.3,
        p95: 21.6,
        p97: 22.1,
        p99: 23.1,
      },
    },
    {
      length: 110,
      m: 18.6043,
      s: 0.09428,
      percentiles: {
        p1: 15.1,
        p3: 15.7,
        p5: 16,
        p15: 16.9,
        p25: 17.5,
        p50: 18.6,
        p75: 19.8,
        p85: 20.6,
        p95: 21.8,
        p97: 22.4,
        p99: 23.4,
      },
    },
    {
      length: 110.5,
      m: 18.8015,
      s: 0.09448,
      percentiles: {
        p1: 15.2,
        p3: 15.8,
        p5: 16.2,
        p15: 17.1,
        p25: 17.7,
        p50: 18.8,
        p75: 20.1,
        p85: 20.8,
        p95: 22.1,
        p97: 22.6,
        p99: 23.7,
      },
    },
    {
      length: 111,
      m: 19.0009,
      s: 0.09467,
      percentiles: {
        p1: 15.4,
        p3: 16,
        p5: 16.3,
        p15: 17.3,
        p25: 17.8,
        p50: 19,
        p75: 20.3,
        p85: 21,
        p95: 22.3,
        p97: 22.8,
        p99: 23.9,
      },
    },
    {
      length: 111.5,
      m: 19.2024,
      s: 0.09487,
      percentiles: {
        p1: 15.5,
        p3: 16.2,
        p5: 16.5,
        p15: 17.4,
        p25: 18,
        p50: 19.2,
        p75: 20.5,
        p85: 21.2,
        p95: 22.6,
        p97: 23.1,
        p99: 24.2,
      },
    },
    {
      length: 112,
      m: 19.406,
      s: 0.09507,
      percentiles: {
        p1: 15.7,
        p3: 16.3,
        p5: 16.7,
        p15: 17.6,
        p25: 18.2,
        p50: 19.4,
        p75: 20.7,
        p85: 21.5,
        p95: 22.8,
        p97: 23.4,
        p99: 24.5,
      },
    },
    {
      length: 112.5,
      m: 19.6116,
      s: 0.09527,
      percentiles: {
        p1: 15.9,
        p3: 16.5,
        p5: 16.8,
        p15: 17.8,
        p25: 18.4,
        p50: 19.6,
        p75: 20.9,
        p85: 21.7,
        p95: 23.1,
        p97: 23.6,
        p99: 24.7,
      },
    },
    {
      length: 113,
      m: 19.819,
      s: 0.09546,
      percentiles: {
        p1: 16,
        p3: 16.7,
        p5: 17,
        p15: 18,
        p25: 18.6,
        p50: 19.8,
        p75: 21.2,
        p85: 21.9,
        p95: 23.3,
        p97: 23.9,
        p99: 25,
      },
    },
    {
      length: 113.5,
      m: 20.028,
      s: 0.09566,
      percentiles: {
        p1: 16.2,
        p3: 16.8,
        p5: 17.2,
        p15: 18.2,
        p25: 18.8,
        p50: 20,
        p75: 21.4,
        p85: 22.2,
        p95: 23.6,
        p97: 24.1,
        p99: 25.3,
      },
    },
    {
      length: 114,
      m: 20.2385,
      s: 0.09586,
      percentiles: {
        p1: 16.3,
        p3: 17,
        p5: 17.4,
        p15: 18.4,
        p25: 19,
        p50: 20.2,
        p75: 21.6,
        p85: 22.4,
        p95: 23.8,
        p97: 24.4,
        p99: 25.6,
      },
    },
    {
      length: 114.5,
      m: 20.4502,
      s: 0.09606,
      percentiles: {
        p1: 16.5,
        p3: 17.2,
        p5: 17.5,
        p15: 18.5,
        p25: 19.2,
        p50: 20.5,
        p75: 21.8,
        p85: 22.6,
        p95: 24.1,
        p97: 24.7,
        p99: 25.8,
      },
    },
    {
      length: 115,
      m: 20.6629,
      s: 0.09626,
      percentiles: {
        p1: 16.7,
        p3: 17.3,
        p5: 17.7,
        p15: 18.7,
        p25: 19.4,
        p50: 20.7,
        p75: 22.1,
        p85: 22.9,
        p95: 24.3,
        p97: 24.9,
        p99: 26.1,
      },
    },
    {
      length: 115.5,
      m: 20.8766,
      s: 0.09646,
      percentiles: {
        p1: 16.8,
        p3: 17.5,
        p5: 17.9,
        p15: 18.9,
        p25: 19.6,
        p50: 20.9,
        p75: 22.3,
        p85: 23.1,
        p95: 24.6,
        p97: 25.2,
        p99: 26.4,
      },
    },
    {
      length: 116,
      m: 21.0909,
      s: 0.09666,
      percentiles: {
        p1: 17,
        p3: 17.7,
        p5: 18.1,
        p15: 19.1,
        p25: 19.8,
        p50: 21.1,
        p75: 22.5,
        p85: 23.4,
        p95: 24.9,
        p97: 25.5,
        p99: 26.7,
      },
    },
    {
      length: 116.5,
      m: 21.3059,
      s: 0.09686,
      percentiles: {
        p1: 17.2,
        p3: 17.9,
        p5: 18.3,
        p15: 19.3,
        p25: 20,
        p50: 21.3,
        p75: 22.8,
        p85: 23.6,
        p95: 25.1,
        p97: 25.7,
        p99: 27,
      },
    },
    {
      length: 117,
      m: 21.5213,
      s: 0.09707,
      percentiles: {
        p1: 17.3,
        p3: 18,
        p5: 18.4,
        p15: 19.5,
        p25: 20.2,
        p50: 21.5,
        p75: 23,
        p85: 23.8,
        p95: 25.4,
        p97: 26,
        p99: 27.3,
      },
    },
    {
      length: 117.5,
      m: 21.737,
      s: 0.09727,
      percentiles: {
        p1: 17.5,
        p3: 18.2,
        p5: 18.6,
        p15: 19.7,
        p25: 20.4,
        p50: 21.7,
        p75: 23.2,
        p85: 24.1,
        p95: 25.6,
        p97: 26.3,
        p99: 27.5,
      },
    },
    {
      length: 118,
      m: 21.9529,
      s: 0.09747,
      percentiles: {
        p1: 17.7,
        p3: 18.4,
        p5: 18.8,
        p15: 19.9,
        p25: 20.6,
        p50: 22,
        p75: 23.5,
        p85: 24.3,
        p95: 25.9,
        p97: 26.5,
        p99: 27.8,
      },
    },
    {
      length: 118.5,
      m: 22.169,
      s: 0.09767,
      percentiles: {
        p1: 17.8,
        p3: 18.6,
        p5: 19,
        p15: 20.1,
        p25: 20.8,
        p50: 22.2,
        p75: 23.7,
        p85: 24.6,
        p95: 26.2,
        p97: 26.8,
        p99: 28.1,
      },
    },
    {
      length: 119,
      m: 22.3851,
      s: 0.09788,
      percentiles: {
        p1: 18,
        p3: 18.7,
        p5: 19.1,
        p15: 20.3,
        p25: 21,
        p50: 22.4,
        p75: 23.9,
        p85: 24.8,
        p95: 26.4,
        p97: 27.1,
        p99: 28.4,
      },
    },
    {
      length: 119.5,
      m: 22.6012,
      s: 0.09808,
      percentiles: {
        p1: 18.2,
        p3: 18.9,
        p5: 19.3,
        p15: 20.5,
        p25: 21.2,
        p50: 22.6,
        p75: 24.2,
        p85: 25.1,
        p95: 26.7,
        p97: 27.4,
        p99: 28.7,
      },
    },
    {
      length: 120,
      m: 22.8173,
      s: 0.09828,
      percentiles: {
        p1: 18.3,
        p3: 19.1,
        p5: 19.5,
        p15: 20.6,
        p25: 21.4,
        p50: 22.8,
        p75: 24.4,
        p85: 25.3,
        p95: 27,
        p97: 27.6,
        p99: 29,
      },
    },
  ],
};
